<template>
  <LayoutDashboard title="Pesquisas de Satisfação">
    <v-card outlined>
      <v-card-title>
        <v-spacer></v-spacer>
        <h3>Registros: {{ getPesquisasSatisfacao.total }} -</h3>
        <v-pagination
          outlined
          total-visible="7"
          v-model="getPesquisasSatisfacao.current_page"
          :length="getPesquisasSatisfacao.last_page"
          @input="listarPosVendas({ ...dataPagina, page: $event })"
        ></v-pagination>
      </v-card-title>
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th width="8%">
                  <v-text-field
                    v-model="dataPagina.id"
                    outlined
                    dense
                    label="Cód."
                    class="mt-2"
                    @input="debouncedPesquisar()"
                    type="number"
                  ></v-text-field>
                </th>
                <th>
                  <v-text-field
                    v-model="dataPagina.cliente"
                    outlined
                    dense
                    label="Cliente"
                    class="mt-2"
                    @input="debouncedPesquisar()"
                  ></v-text-field>
                </th>
                <th width="10%">
                  <v-text-field
                    v-model="dataPagina.vendaId"
                    outlined
                    dense
                    label="Cód. Venda"
                    class="mt-2"
                    @input="debouncedPesquisar()"
                    type="number"
                  ></v-text-field>
                </th>
                <th>Funcionário</th>
                <th width="8%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="p in getPesquisasSatisfacao.data" :key="p.id">
                <td align="center">{{ p.id }}</td>
                <td>{{ p.venda.cliente ? p.venda.cliente.nome : "" }}</td>
                <td align="center">{{ p.venda_id }}</td>
                <td>{{ p.funcionario.nome }}</td>
                <td>
                  <TooltipButton
                    @click.native="visualizarPesquisaSatisfacao(p)"
                    classButton="ml-2"
                    subtitle="Visualizar"
                    icon="search"
                    color="primary"
                    v-if="
                      $helper.verificaPermissao(
                        'visualizar-pesquisa-satisfacao'
                      )
                    "
                  />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
    <ModalCadastro />
  </LayoutDashboard>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ModalCadastro from "@/pages/crm/pesquisaSatisfacao/ModalCadastro";
var _ = require("lodash");

export default {
  components: {
    ModalCadastro,
  },
  data: () => ({
    dataPagina: {
      id: "",
      vendaId: "",
      cliente: "",
    },
  }),
  computed: {
    ...mapGetters(["getPesquisasSatisfacao"]),
  },
  methods: {
    ...mapActions([
      "listarPesquisaSatisfacao",
      "setModalCadastroPesquisaSatisfacao",
      "visualizarPesquisaSatisfacao",
    ]),
    pesquisar() {
      this.listarPesquisaSatisfacao(this.dataPagina);
    },
  },
  created() {
    this.listarPesquisaSatisfacao({});
    this.debouncedPesquisar = _.debounce(this.pesquisar, 300);
  },
};
</script>